import http from './http';
import DefaultDate from '../filters/DefaultDate';

export default {
    getAll(fromDate = null) {
        const query = fromDate !== null ? `?datetime=${DefaultDate(fromDate)}` : null;
        const endpoint = '/globalnote';
        const url = query ? endpoint + query : endpoint;

        return http.get(url);
    },
    getAllFromDate(fromDate) {
        return this.getAll(fromDate);
    },
    getSingle(id, date) {
        return http.get(`/globalnote/${id}?datetime=${DefaultDate(date)}`);
    },
    getSingleVersions(id) {
        return http.get(`/globalnote/${id}/versions`);
    },
    create(globalNote) {
        return http.post('/globalnote', globalNote);
    },
    update(globalNote) {
        return http.put(`/globalnote/${globalNote.id}`, globalNote);
    },
    newVersion(globalNote) {
        return http.put(`/globalnote/${globalNote.id}/newversion`, globalNote);
    },
};
